// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3f929d538f109b886bff","655":"b0e4aaae5baff9540c02"}[chunkId] + ".js";
};